// import { isEmpty } from 'lodash'

import { pp, ppw } from './LogUtil'

export const onBackPressed = () => {
  pp('onBackPressed()')
  ;(global as any)?.MicroBridge?.onBackPressed()
  ;(global as any)?.webkit?.messageHandlers?.onBackPressed?.postMessage({
    message: 'onBackPressed',
  })
}

export const openGlossary = (at: string) => {
  ppw('openGlossary()', at)
  ;(global as any)?.MicroBridge?.openGlossary(at)
  ;(global as any)?.webkit?.messageHandlers?.openGlossary?.postMessage(at)
}

export const onUnauthorized = () => {
  pp('onUnauthorized()')
  ;(global as any)?.MicroBridge?.onUnauthorized()
  ;(global as any)?.webkit?.messageHandlers?.onBackPressed?.postMessage({
    message: 'onUnauthorized',
  })
}

// export const openBrowser = (url?: string) => {
//   if (!url || isEmpty(url)) return
//   if ((global as any).ClinicBridge) {
//     ;(global as any).ClinicBridge.openBrowser(url)
//   }
//
//   if (
//     (global as any).webkit.messageHandlers &&
//     (global as any).webkit.messageHandlers.openBrowser
//   ) {
//     ;(global as any).webkit.messageHandlers.openBrowser.postMessage(url)
//   }
// }
